import React from 'react';
import { Document } from '@react-pdf/renderer';
import { PrintDataFields } from '@repo/print-pdf/arbre/print';

import { PDFDocument } from '../one';

interface MultiPDFDocumentProps {
  printDataList: PrintDataFields[];
  arbreIds: number[];
}

export const MultiPDFDocument: React.FC<MultiPDFDocumentProps> = ({
  printDataList,
  arbreIds,
}) => {

  const renderFiche = (data: PrintDataFields, inventaireId: number) => {

    return (
      <>
        <PDFDocument data={data} inventaireId={inventaireId} />
      </>
    );
  };

  return (
    <Document>
      {printDataList.map((data, index) => renderFiche(data, arbreIds[index] || index))}
    </Document>
  );
};

